import { FC } from 'react';

import { cn } from 'utils/helpers';
import { cva } from 'class-variance-authority';

interface PROPS {
  length: number;
  value: string;
  error?: boolean;
  success?: boolean;
}

const charClassnames = cva(
  [
    'border-b-2 px-4 pb-4',
    'w-[70px] h-[50px]',
    'text-center text-4xl font-semibold',
  ],
  {
    variants: {
      hasError: {
        true: ['!border-danger-base', '!text-danger-base'],
        false: [],
      },
      hasValue: {
        true: ['border-secondary-base'],
        false: ['border-disabled'],
      },
      isSuccess: {
        true: ['text-primary-base border-primary-base'],
        false: ['text-secondary-base'],
      },
    },
    defaultVariants: {
      hasError: false,
      isSuccess: false,
      hasValue: false,
    },
  },
);

const CharField: FC<PROPS> = ({ length, value, error, success }) => {
  const char: JSX.Element[] = [];

  for (let x = 0; x < length; x += 1) {
    char.push(
      <div
        className={cn(
          charClassnames({
            hasError: error,
            hasValue: value.length === x || !!value[x],
            isSuccess: success,
          }),
        )}
        key={x}
      >
        {value[x] ?? ''}
      </div>,
    );
  }

  return (
    <div className="absolute top-0 flex flex-col h-full w-full items-center">
      <div className="md:m-auto">
        <div className="flex gap-x-2 md:gap-x-6">{char}</div>
      </div>
    </div>
  );
};

export default CharField;
